export const CONFIG_SSO = 'sso';
export const CONFIG_MFA = 'mfa';